export const cp = {
    cp:{
        menuGroups:{
            labels:{
                mts_tickets: { 
                    en: 'Tickets' 
                },
                mts_rules: { 
                    en: 'Rules' 
                },
                mts_elk_alerts: { 
                    en: 'ELK alerts' 
                },

                qk_run_export: { 
                    en: 'Mindbox export runs' 
                },
                qk_download_files: { 
                    en: 'Download/Parce files' 
                },
                qk_send_to_ucrm: { 
                    en: 'Sendings to UCRM' 
                },

                qk_send_to_mindbox: { 
                    en: 'Sendings to Mindbox' 
                },
                audit_api: { 
                    en: 'API Audit' 
                },

                qk_datasync_sync_consumer: { 
                    en: 'Synchronization of consumers' 
                },
                qk_datasync_sync_consumercommunicationsubscription: { 
                    en: 'Synchronization of consumers communications subscription' 
                },
                qk_datasync_sync_consumertasksteps: { 
                    en: 'Synchronization of consumer task steps' 
                },
                qk_datasync_sync_consumerfirstacquisition: { 
                    en: 'Synchronization of consumers first acquisition' 
                },
                qk_datasync_sync_person: { 
                    en: 'Synchronization of person' 
                },
                qk_datasync_sync_rrpmarketingmessagecontact: { 
                    en: 'Synchronization of RRP Marketing Message Contact' 
                },
                qk_datasync_sync_product: { 
                    en: 'Synchronization of product' 
                },
                qk_datasync_sync_order: { 
                    en: 'Synchronization of order' 
                },
                qk_datasync_sync_lendingorder: { 
                    en: 'Synchronization of lending order' 
                },
                qk_datasync_sync_lastretailbrand: { 
                    en: 'Synchronization of lending order' 
                },
                qk_datasync_sync_lastretailbrandreference: { 
                    en: 'Synchronization of lending order' 
                },
                qk_datasync_sync_consumerallocations: { 
                    en: 'Synchronization of allocations' 
                },
                qk_datasync_sync_geographyconsumer: { 
                    en: 'Synchronization of geography consumer' 
                },
                datasync_mappings: { 
                    en: 'Mappings' 
                },
                smpplogs: { 
                    en: 'SMPP Logs' 
                },
                smppsettings: { 
                    en: 'SMPP Settings' 
                },
                smppperformance: { 
                    en: 'SMPP Performance' 
                },
                qk_datasync_sync_equipmentproductinstance: { 
                    en: 'Synchronization of product instance status' 
                },
            }
        }
    }
}